import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import styles from '../About/styles.module.scss';
import { useRedirectAndScroll, useAppSelector } from 'hooks';
import { Link } from 'react-router-dom';
import { useTranslates } from 'providers/translates';
import { isVac } from 'utilities/is-vac';
import { ContentVAC } from './components/ContentVAC';
import { ContentMemorial } from './components/ContentMemorial';
import { TProfile } from 'api/http-client/profileTypes';
import { useAuth } from 'providers/auth-provider';
import { Language } from 'providers/translates/enums';

const HowToUsePage: React.FC = () => {
  const { translates: t, selectedLang } = useTranslates();
  const isFrench = selectedLang === Language.FRENCH;
  const [searchParams] = useSearchParams();
  const { onlyScroll } = useRedirectAndScroll({});
  const user = useAuth().user as unknown as TProfile;
  const editableQuilt = useAppSelector((state) => state.quilt.editableQuilt);

  const nameRow = `Name associated with your account: ${user?.firstName ?? ''} ${user?.lastName ?? ''}\n`;
  const emailRow = `Email address associated with your account: ${user?.email ?? ''}\n`;
  const quiltNameRow = `Name of the quilt square you need help with: ${editableQuilt?.firstName ?? ''} ${editableQuilt?.lastName ?? ''}\n`;
  const issueOrConcernRow = `Issue or concern:`;

  const nameRowVac = `Name associated with your account: ${user?.firstName ?? ''} ${user?.lastName ?? ''}\n`;
  const emailRowVac = `Email address associated with your account: ${user?.email ?? ''}\n`;
  const quiltNameRowVac = `Name of the quilt square you need help with: ${editableQuilt?.firstName ?? ''} ${editableQuilt?.lastName ?? ''}\n`;
  const issueOrConcernRowVac = `Issue or concern:`;

  const nameRowFr = `Nom associé à votre compte: ${user?.firstName ?? ''} ${user?.lastName ?? ''}\n`;
  const emailRowFr = `Adresse courriel associée à votre compt: ${user?.email ?? ''}\n`;
  const quiltNameRowFr = `Nom du carreau de courtepointe pour lequel vous avez besoin d’aide: ${editableQuilt?.firstName ?? ''} ${editableQuilt?.lastName ?? ''}\n`;
  const issueOrConcernRowFr = `De quoi s’agit-il?`;

  useEffect(() => {
    const scrollTo = searchParams?.get('visible');
    if (scrollTo) {
      onlyScroll(scrollTo);
    }
  }, []);

  let contactUsEmail: { subject: string; body: string; };

  if (isVac()) {
    contactUsEmail = isFrench ? {
      subject: encodeURIComponent('J’ai une question concernant SaluonsLeurService.ca'),
      body: encodeURIComponent(
        `\n\n\nN.B. – Si vous êtes un utilisateur actuel du site SaluonsLeurService.ca et que vous avez besoin d’assistance, veuillez nous fournir les renseignements suivants pour nous aider à vous faciliter la tâche.\n\n${nameRowFr}${emailRowFr}${quiltNameRowFr}${issueOrConcernRowFr}`
      ),
    } : {
      subject: encodeURIComponent('I have a question about SalutingService.ca'),
      body: encodeURIComponent(
        `\n\n\nNote: If you are a current SalutingService.ca user and are looking for assistance, please provide us with the following information so we can help you as easily as possible:\n\n${nameRowVac}${emailRowVac}${quiltNameRowVac}${issueOrConcernRowVac}`
      ),
    }
  } else {
    contactUsEmail = {
      subject: encodeURIComponent('I have a question about the Canadian Healing Quilt'),
      body: encodeURIComponent(
        `\n\n\nNote: If you are a current Canadian Healing Quilt user and are looking for assistance please provide us with the following information so we can help you as easily as possible:\n\n${nameRow}${emailRow}${quiltNameRow}${issueOrConcernRow}`
      )
    }
  }

  const anchorContactUsEmail = () => {
    return (
      <a href={`mailto:info@virtualhospice.ca?subject=${contactUsEmail.subject}&body=${contactUsEmail.body}`}>
        info@virtualhospice.ca
      </a>
    )
  }

  return (
    <section className="content center">
      <h1 className={styles.titleH1}>{t?.howToUse?.title ?? 'How To Use'}</h1>

      {isVac() ? (
        <ContentVAC />
      ) : (
        <ContentMemorial />
      )}      
    </section>
  );
};

export default HowToUsePage;
